import React from 'react';
import { withStyles } from '@material-ui/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import classnames from 'classnames';

const styles = theme => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '32px',
  },
  title: {
    marginBottom: '32px',
    color: '#1e5180',
    fontSize: '2.5rem',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  logo: {
    maxWidth: '300px',
    height: 'auto',
    marginBottom: '24px',
  },
  subtitle: {
    color: '#666',
    fontSize: '1.2rem',
    textAlign: 'center',
    marginTop: '16px',
  },
});

const CallCenterDashboard = ({ classes }) => {
  return (
    <div className={classnames('flex-1', classes.root)}>
      <Box display="flex" flexDirection="column" alignItems="center">
        <img 
          src="/assets/images/bluesky-vue-logo-only.png" 
          alt="Bluesky Logo" 
          className={classes.logo}
        />
        <Typography variant="h2" className={classes.title}>
          Call Center Dashboard
        </Typography>
        <Typography variant="h6" className={classes.subtitle}>
          Welcome to the Call Center Management Portal
        </Typography>
      </Box>
    </div>
  );
};

CallCenterDashboard.propTypes = {};

CallCenterDashboard.defaultProps = {};

export default withStyles(styles)(CallCenterDashboard); 